import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : "";
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google/session", { session_id: sid })
      .then((r) => { setUser(r.data); nav("/profilo", { replace: true }); })
      .catch(() => { setUser(false); nav("/login", { replace: true }); });
  }, [nav, setUser]);
  return null;
}
